export default __webpack_public_path__ + "static/media/file-cabinet-icon.c401b5b9.svg";